export const termsAndConditions = [
    {
      title: { en: "Terms & Conditions", ar: "الشروط والأحكام" },
      description: {
        en: "This document outlines the terms and conditions governing the use of the digital platforms of the Saudi Arabian Football Federation (“the Federation”), including its websites, applications, and other related services.",
        ar: "توضح هذه الوثيقة الشروط والأحكام الخاصة باستخدام المنصات الرقمية التابعة للاتحاد السعودي لكرة القدم، بما في ذلك المواقع والتطبيقات والخدمات الأخرى.",
      },
    },
    {
        title: { en: "Definitions", ar: "التعريفات" },
        description: 
        {
          en: `• “Federation,” “we,” “us”: Refers to the Saudi Arabian Football Federation, which owns and operates the platform.
• “User”: Any individual who accesses or uses the Federation’s website, applications, or digital services.
• “Platform”: All digital channels owned by the Federation, including its official website, mobile apps, and electronic services.
• “Personal Data”: Any information that directly or indirectly identifies the user.`,
          ar: `• "الاتحاد" أو "نحن": يُقصد بها الاتحاد السعودي لكرة القدم، الجهة المالكة والمسؤولة عن المنصة.
• "المستخدم": أي شخص يستخدم الموقع الإلكتروني أو التطبيقات أو الخدمات الرقمية الخاصة بالاتحاد.
• "المنصة": جميع القنوات الرقمية التابعة للاتحاد، بما في ذلك الموقع الرسمي والتطبيقات والخدمات الإلكترونية.
• "البيانات الشخصية": أي بيانات تؤدي إلى التعرف على هوية المستخدم بشكل مباشر أو غير مباشر.`
        }
      },
    {
      title: { en: "1. Acceptance of Terms", ar: "1. القبول" },
      description: {
        en: "By accessing or using the Platform, you expressly agree to be bound by these Terms & Conditions. If you do not agree to all terms herein, you must immediately cease using the Platform and any associated services.",
        ar: "باستخدامك للمنصة، فإنك توافق على الالتزام بهذه الشروط والأحكام. وفي حال عدم موافقتك، يتوجب عليك الامتناع فوراً عن استخدام المنصة أو أي من خدماتها.",
      },
    },
    {
      title: { en: "2. Prohibited Conduct", ar: "2. السلوك المحظور" },
      description: {
        en: `Users are strictly prohibited from:\n
• Attempting to breach, scan, or test the Platform’s security or vulnerability measures.\n• Uploading or transmitting files containing viruses or malicious code.\n• Disseminating unsolicited promotional or advertising messages under the Federation’s identity.\n• Impersonating the Federation or claiming to represent it without official authorization.`,
        ar: `يُمنع على المستخدمين القيام بأي من الأفعال التالية:\n
•	محاولة اختراق، مسح، أو اختبار المنصة بحثًا عن ثغرات.\n•	تحميل أو إرسال ملفات تحتوي على فيروسات أو أكواد ضارة.\n•	إرسال رسائل ترويجية أو دعائية غير مرغوب فيها باستخدام اسم أو منصة الاتحاد السعودي لكرة القدم.\n•	انتحال شخصية الاتحاد أو الادعاء بتمثيله دون تصريح رسمي.`,
      },
    },
    {
      title: { en: "3. User Accounts", ar: "3. حسابات المستخدمين" },
      description: {
        en: `• Users bear sole responsibility for maintaining the confidentiality of their login credentials.\n• Users must provide accurate and current information during account creation and continued use.\n• The Federation reserves the right to suspend or terminate accounts in cases of misuse or violation of these Terms.`,
        ar: `•	يتحمل المستخدم كامل المسؤولية عن الحفاظ على سرية بيانات تسجيل الدخول الخاصة به.\n•	يلتزم المستخدم بتقديم معلومات دقيقة ومحدثة عند إنشاء الحساب أو استخدام المنصة.\n•	يحتفظ الاتحاد السعودي لكرة القدم بحق تعليق أو إلغاء الحسابات في حال وجود إساءة استخدام أو مخالفة لهذه الشروط.`,
      },
    },
    {
      title: { en: "4. Intellectual Property", ar: "4. الملكية الفكرية" },
      description: {
        en: `• All content on the Platform including but not limited to texts, images, designs, logos, and audiovisual materials is the exclusive property of the Federation and is protected under applicable intellectual property laws in the Kingdom of Saudi Arabia.\n• Any reuse, distribution, or modification of Platform content is strictly prohibited without the Federation’s prior written consent.`,
        ar: `•	جميع المحتويات والمواد المنشورة على المنصة بما في ذلك على سبيل المثال لا الحصر: النصوص، الصور، التصاميم، الشعارات، ومقاطع الفيديو هي ملك حصري للاتحاد السعودي لكرة القدم، ومحمية بموجب أنظمة الملكية الفكرية المعمول بها في المملكة العربية السعودية.\n•	يمنع إعادة استخدام أو توزيع أو تعديل أي من محتويات المنصة دون الحصول على إذن خطي مسبق من الاتحاد.`,
      },
    },
    {
      title: { en: "5. External Links", ar: "5. الروابط الخارجية" },
      description: {
        en: "The Platform may contain links to third-party websites or services. The Federation assumes no responsibility for the content, policies, or security practices of such external sites, and the inclusion of such links does not constitute endorsement or recommendation.",
        ar: "قد تتضمن المنصة روابط إلكترونية لمواقع أو منصات لأطراف خارجية. لا يتحمل الاتحاد أي مسؤولية عن محتوى تلك المواقع أو سياساتها أو ممارساتها الأمنية، ولا يعد إدراج هذه الروابط بمثابة مصادقة أو توصية.",
      },
    },
    {
      title: { en: "6. Termination of Use", ar: "6. إنهاء الاستخدام" },
      description: {
        en: `For violations of these Terms, the Federation may, at its discretion:\n
• Issue formal warnings to the user.\n• Temporarily suspend platform access.\n• Permanently revoke access, depending on the gravity or frequency of breaches.\nThe Federation bears no liability following termination of Access.`,
        ar: `يحتفظ الاتحاد بالحق في اتخاذ الإجراءات التالية عند مخالفة المستخدم لهذه الشروط:\n
•	توجيه إنذارات رسمية للمستخدم.\n•	تعليق الوصول مؤقتًا.\n•	إنهاء الوصول بشكل دائم بناءً على خطورة أو تكرار الانتهاكات. ولا يتحمل الاتحاد السعودي لكرة القدم أي مسؤولية بعد الإنهاء.`,
      },
    },
    {
      title: { en: "7. Disclaimer of Liability", ar: "7. إخلاء المسؤولية" },
      description: {
        en: `• The Platform is provided “as is,” without any warranties express or implied regarding uninterrupted access or error-free performance.\n• The Federation disclaims all liability for any direct, indirect, incidental, or consequential damages arising from use of the Platform.`,
        ar: `•	تُقدَّم المنصة كما هي، دون ضمانات بانعدام الانقطاع أو الأخطاء.\n•	لا نتحمل أي مسؤولية عن أي خسائر مباشرة أو غير مباشرة نتيجة الاستخدام.`,
      },
    },
    {
      title: { en: "8. Amendments", ar: "8. التعديلات" },
      description: {
        en: "The Federation reserves the right to modify these Terms & Conditions at any time. Continued use of the Platform after publication of such amendments constitutes your implicit consent to the updated terms.",
        ar: "يحق للاتحاد تعديل هذه الشروط والأحكام في أي وقت. ويعد استمرار المستخدم في استخدام المنصة بعد نشر التعديلات موافقة ضمنية منه على تلك التعديلات.",
      },
    },
    {
      title: { en: "9. Governing Law", ar: "9. القانون المعمول به" },
      description: {
        en: "These Terms and Conditions shall be governed, interpreted, and enforced in accordance with the laws and regulations of the Kingdom of Saudi Arabia.",
        ar: "تخضع هذه الشروط والأحكام لأنظمة وقوانين المملكة العربية السعودية وتفسر وتطبق بموجبها.",
      },
    },
    {
      title: { en: "10. Reference Language", ar: "10. اللغة المرجعية" },
      description: {
        en: "This Arabic version constitutes the authoritative text. In the event of any conflict between this version and any translation, the Arabic text shall prevail.",
        ar: "تم إعداد الشروط والأحكام باللغة العربية، وفي حال وجود أي تعارض مع ترجمات أخرى، تُعتَمد النسخة العربية.",
      },
    },
    {
      title: { en: "11. Contact Information", ar: "11. التواصل" },
      description: {
        en: "For inquiries, please contact: [info@saff.com.sa].",
        ar: "للاستفسارات، يرجى التواصل معنا عبر: [info@saff.com.sa].",
      },
    },
  ];